import apiService from "./api";

const companyService = {
  // Add warehouse users fetch
  getCompanies() {
    return apiService.get(`/companies`);
  },
  getBranches(params) {
    return apiService.get(`/companies/lists`, params);
  },
  deleteCompany(id) {
    return apiService.delete(`/companies/${id}`);
  },
  updateCompany(id, data) {
    return apiService.put(`/companies/${id}`, data);
  },
  createCompany(data) {
    return apiService.post(`/companies`, data);
  },
  changeEveryDayOffer(data) {
    return apiService.post(`/companies/change-everyday-offer`, data);
  },
  // Credit operations
  saveCredit(data) {
    return apiService.post(`/companies/save-credit`, data);
  },
  getCredit(companyId) {
    return apiService.post(`/companies/get-credit`, { company_id: companyId });
  },
  setCreditActive(data) {
    return apiService.post(`/companies/credit-is-active`, data);
  },
  setIsCredit(companyId, data) {
    return apiService.put(`/companies/${companyId}/is-credit`, data);
  },
  // Partner restaurant operations
  getCompanyRestaurants(companyId, params) {
    return apiService.get(`/companies/${companyId}/show-restaurants`, params);
  },
  addRestaurantsToCompany(companyId, data) {
    return apiService.post(`/companies/${companyId}/add-restaurants`, data);
  },
  // Restaurant settings operations
  changeDeliverySettings(data) {
    return apiService.post('/companies/change-delivery-settings', data);
  },
  setCompanyLimit(data) {
    return apiService.post('/companies/set-company-limit', data);
  },
  setCompanyMealAmount(data) {
    return apiService.post('/companies/set-company-meal-amount', data);
  },
  setCompanyShiftLimit(data) {
    return apiService.post('/companies/set-company-shift-limit', data);
  },
  setNewCompanyLimit(data) {
    return apiService.post('/companies/set-new-company-limit', data);
  },
  changeCompanyLimit(data) {
    return apiService.post('/companies/change-company-limit', data);
  },
  setCompanyCanOrderExtra(data) {
    return apiService.post('/companies/set-company-can-order-extra', data);
  },
  // Company settings operations
  changeShowPrice(company) {
    return apiService.post('/companies/change-show-price', company);
  },
  storeSettings(company) {
    return apiService.post('/companies/store-settings', company);
  },
  saveQuestionnaire(companyId, questionnaires) {
    return apiService.post(`/companies/${companyId}/questionnaire`, { questionnaires });
  },
  getQuestionnaire(companyId) {
    return apiService.get(`/companies/${companyId}/questionnaire`);
  },
  // Delivery companies operations
  getDeliveryCompanies() {
    return apiService.get('/companies/companies-delivery');
  },
  createDeliveryCompany(data) {
    return apiService.post('/companies/companies-delivery', data);
  },
  updateDeliveryCompany(companyId, data) {
    return apiService.put(`/companies/${companyId}/companies-delivery`, data);
  },
  changeCompanyDeliveryStatus(data) {
    return apiService.post('/companies/change-company-delivery-status', data);
  },
  changeUserDeliveryStatus(data) {
    return apiService.post('/companies/change-user-delivery-status', data);
  },
  storeDeliveryCompanyRestaurants(data) {
    return apiService.post('/companies/companies-delivery-restaurant', data);
  },
  // Company list operations
  getCompanyList(companyId) {
    return apiService.get(`/companies/list/${companyId}`);
  },
  // Get company by ID
  getCompanyById(companyId) {
    return apiService.get(`/companies/${companyId}`);
  },
  // Get parent companies with children
  getParentCompanies(companyId) {
    return apiService.get(`/companies/parent/${companyId}`);
  },
  // Get companies with restaurants
  getCompaniesWithRestaurants() {
    return apiService.get('/companies', { restaurants: true });
  },
  // Get company users
  getCompanyUsers(companyId) {
    return apiService.get(`/companies/${companyId}/users`);
  },
  // Get user companies
  getUserCompanies(userId) {
    return apiService.post('/companies/user-companies', { user_id: userId });
  },
  setMenuType(companyId, restaurantId, data) {
    return apiService.post(`/companies/${companyId}/restaurant/${restaurantId}/set-meny-type`, data);
  },
  setResturantOptions(companyId, restaurantId, data) {
    return apiService.post(`/companies/${companyId}/restaurant/${restaurantId}/set-resturant-options`, data);
  },
};

export default companyService;
